import PostDetail from 'components/Hero/PostHero/PostDetail';

import type { PostDetailProps } from 'components/Hero/PostHero/PostDetail';
import type { ReactNode } from 'react';

interface CaseStudyDetailProps extends PostDetailProps {
  children: ReactNode;
}

export const CaseStudyPostDetail = ({ children, ...props }: CaseStudyDetailProps) => (
  <PostDetail {...props} className="w-full md:w-1/2 md:items-start">
    {children}
  </PostDetail>
);

export const CaseStudyDetailRow = ({ children }: { children: ReactNode }) => (
  <div className="mx-auto flex flex-col items-start gap-8 md:w-full md:flex-row lg:gap-6 xl:mx-0">{children}</div>
);
